import { createRouter, createRoute, createRootRoute, Outlet } from '@tanstack/react-router';
import { LandingPage } from './pages/LandingPage';
import { AppShell } from './AppWrapper';

// Root layout — just renders the matched route
const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

// Landing page at /
const landingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: LandingPage,
});

// App layout at /app — handles auth, renders App + Outlet for child routes
const appLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/app',
  component: AppShell,
});

// /app/$page — App.tsx reads this via useLocation() to set active view
const appPageRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '$page',
  component: () => null,
});

const routeTree = rootRoute.addChildren([
  landingRoute,
  appLayoutRoute.addChildren([appPageRoute]),
]);

export const router = createRouter({ routeTree });

// Type registration for TanStack Router
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
